import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import '@/assets/css/global.css'
import axios from 'axios'
import VueAMap from 'vue-amap'
import VueCookies from 'vue-cookies'
import {Message} from 'element-ui'
import {MessageBox} from 'element-ui'
import common from '@/assets/js/common.js'
import el from "element-ui/src/locale/lang/el";
import Viewer from 'v-viewer'
Vue.use(Viewer);
import 'viewerjs/dist/viewer.css';
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

/**
 * 请求遮罩层
 * @type {string}
 */
Vue.prototype.openLoading = function () {
    let loading = this.$loading({           // 声明一个loading对象
        lock: true,                             // 是否锁屏
        text: '正在加载...',                     // 加载动画的文字
        spinner: 'el-icon-loading',             // 引入的loading图标
        background: 'rgba(0, 0, 0, 0.3)',       // 背景颜色
        target: '.sub-main',                    // 需要遮罩的区域
        body: true,
        customClass: 'mask'                     // 遮罩层新增类名
    });
    setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
        loading.close();                        // 关闭遮罩层
    }, 3000);
    return loading;
}


// 配置请求根路径 配置这个后错误请求产生跨域影响
//axios.defaults.withCredentials = true;
axios.defaults.baseURL = common.api;
/**
 * axios全局请求拦截器
 */
axios.interceptors.request.use(config => {
    let token = VueCookies.get('manager_token');
    config.headers.common = {
        'Access-Control-Allow-Methods': 'POST,GET,OPTIONS',
        'Authorization': token
    };
    config.timeout = 10000;
    return config;
}, error => {
    Message.error('请求错误！');
    return Promise.resolve(error);
});
/**
 * axios全局响应拦截器
 */
let inBox = false;
axios.interceptors.response.use((response) => {
    let res = response.data;
    if (res.code !== 0) {
        Message.error(res.text || '响应错误！')
    } else {
        if (res.text) {
            Message.success(res.text)
        }
    }
    return res;
}, error => {
    let err = error.response;
    if (error && err) {
        let errCode = err.data.code || err.status;
        if (errCode === 401 && !inBox) {
            inBox = true;
            MessageBox.confirm('鉴权未通过,请重新登录', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                router.push('/login');
            });
            setTimeout(() => {
                inBox = false;
            }, 500);
        } else {
            Message.error(err.data.text || '系统异常！');
        }
    } else {
        Message.error('系统异常！');
    }
    return Promise.reject(error)
});
// 挂在到Vue实例，后面可通过this调用
Vue.prototype.$http = axios;
Vue.prototype.common = common;

Vue.config.productionTip = false;
// 设置vue-cookie
Vue.use(VueCookies);
Vue.prototype.$cookies = VueCookies;
Vue.$cookies.config('0');
// 发布订阅
Vue.prototype.bus = new Vue();

if (common.profiles !== 'gongan') {
    Vue.use(VueAMap)
    VueAMap.initAMapApiLoader({
        // 高德key
        key: '8ebbc129f4275c30209ba1ac8f1a4823',
        // 插件集合 （插件按需引入）
        plugin: ['AMap.Geocoder', 'AMap.Geolocation', 'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale',
            'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
        // 版本号
        v: '1.4.15',
        // ui版本号
        uiVersion: '1.0.11'
    });
}


new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
